export const APP_CONFIG_DEFAULTS = {
    companyName: 'LiveKit',
    pageTitle: 'LiveKit Embed',
    pageDescription: 'A web embed connected to an agent, built with LiveKit',
    supportsChatInput: true,
    supportsVideoInput: true,
    supportsScreenShare: true,
    isPreConnectBufferEnabled: true,
    logo: '/lk-logo.svg',
    accent: '#002cf2',
    logoDark: '/lk-logo-dark.svg',
    accentDark: '#1fd5f9',
    startButtonText: 'Start call',
};
